import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { IndentedCard, Skeleton } from 'js/components/design-system';

const LawyerFeedbackMetadataSkeleton = (props) => {
  const { className, animated } = props;
  return (
    <Skeleton
      className={classnames('lawyer-feedback-metadata-skeleton', className)}
      animated={animated}
    >
      <IndentedCard>
        <div className="skeleton-row">
          <div className="skeleton-column">
            <div className="skeleton-bone" />
          </div>
        </div>
        <div className="skeleton-row">
          <div className="skeleton-column">
            <div className="skeleton-bone" />
          </div>
          <div className="skeleton-column">
            <div className="skeleton-bone" />
          </div>
        </div>
      </IndentedCard>
    </Skeleton>
  );
};

LawyerFeedbackMetadataSkeleton.defaultProps = {
  animated: false,
};

LawyerFeedbackMetadataSkeleton.propTypes = {
  className: PropTypes.string,
  animated: PropTypes.bool,
};

export default LawyerFeedbackMetadataSkeleton;
